import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/holiday-packages/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HolidayPackageCard"] */ "/app/src/components/HolidayPackageCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Pagination"] */ "/app/src/components/Pagination/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TourHero"] */ "/app/src/heros/TourHero/index.tsx");
